export const defaultRackState = {
  environment: '',
  kits: {
    software: [],
    content: [],
    media: []
  },
  components: {
    software: [],
    content: [],
    media: [],
    onemedia: []
  },
  rack: {
    systemType: '',
    gateway: {
      size: 'small',
      diskSize: 'small',
      persistData: 'true',
      enabled: true,
      resources: {
        limits: {
          cpu: `2000m`,
          memory: `2000M`
        }
      }
    },
    vms: [],
    lrus: {
      ah: { enabled: false, persistData: true, size: 'small', diskSize: 'small' },
      is: { enabled: false, persistData: true, size: 'small', diskSize: 'small' },
      next_is: { enabled: false, persistData: true, size: 'small', diskSize: 'small' },
      cs4: { enabled: false, persistData: true, size: 'small', diskSize: 'small' },
      next_cs4: { enabled: false, persistData: true, size: 'small', diskSize: 'small' },
      ex3_nc: { enabled: false, persistData: true, size: 'small', diskSize: 'small' },
      next_nc: { enabled: false, persistData: true, size: 'small', diskSize: 'small' },
      fs05: { enabled: false, persistData: true, size: 'small', diskSize: 'small' },
      bc03: {
        enabled: false,
        persistData: true,
        size: 'small',
        diskSize: 'small'
      },
      smartmonitor: {
        enabled: false,
        persistData: true,
        size: 'small',
        diskSize: 'small',
        config: {
          ip: '172.17.128.2',
          type: '196',
          subtype: '153',
          boardId: '66'
        }
      },
      ped: {
        enabled: false,
        persistData: true,
        size: 'small',
        diskSize: 'small'
      },
      qasb: {
        enabled: false,
        persistData: true,
        size: 'small',
        diskSize: 'small',
        config: {
          webrtc: true,
          ip: '172.17.128.2',
          type: '196',
          subtype: '180'
        }
      }
    },
    simulatedServices: {
      modem: {
        enabled: false
      },
      groundConnectivity: {
        enabled: false
      },
      flightSimulator: {
        enabled: false
      }
    },
    autoRackStop: {
      enabled: true
    },
    mikrotik: {
      enabled: false
    }
  }
};
